'use client';

import { getWebsiteId } from '@/app/website/[id]/customer/dashboard/components/sva/vialivros/components/vialivros-activate.service';
import { CLIENT_PATHS } from '@/config/routes/client-paths';
import { AuthCustomerService } from '@/layers/application/services/auth/customer/auth-customer.service';
import { CpfCnpj } from '@/layers/domain/value-objects/profile/cpf-cnpj.vo';
import { loginPasswordSchema } from '@/shared/application/validation/schemas/auth/password.schema';
import { cpfCnpjSchema } from '@/shared/application/validation/schemas/profile/cpf-cnpj.schema';
import { InputPassword } from '@/shared/components/features/auth/inputs/auth-inputs.components';
import { CustomerLoginDto } from '@/shared/components/forms/auth/customer/dtos/customer-login.dto';
import { Button } from '@/shared/components/ui/button/button.component';
import { VerticalForm } from '@/shared/components/ui/form/vertical-form/vertical-form.component';
import { Input } from '@/shared/components/ui/input/input.component';
import { LinkButton } from '@/shared/components/ui/link/link-button/link-button.component';
import { Link } from '@/shared/components/ui/link/link.component';
import { yupResolver } from '@hookform/resolvers/yup';
import { useRouter } from 'next/navigation';
import { FC, useTransition } from 'react';
import { useForm } from 'react-hook-form';
import { useHookFormMask } from 'use-mask-input';
import { object } from 'yup';

export const CustomerLoginForm: FC = () => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<CustomerLoginDto>({
    resolver: yupResolver(
      object({
        cpfCnpj: cpfCnpjSchema,
        password: loginPasswordSchema,
      }),
    ),
  });

  const registerWithMask = useHookFormMask(register);
  const router = useRouter();

  const [isPending, startTransition] = useTransition()

  return (
    <VerticalForm
      id="form-customer-login"
      onSubmit={handleSubmit((data) =>
        startTransition(() => AuthCustomerService.login(router)(data))
      )}
    >
      <Input
        id="input-cpf-cnpj"
        label="CPF/CNPJ"
        hoverAnimations
        {...registerWithMask('cpfCnpj', CpfCnpj.masks())}
        error={
          errors.cpfCnpj?.message ? String(errors.cpfCnpj?.message) : undefined
        }
      />
      <InputPassword
        {...register('password')}
        error={
          errors.password?.message
            ? String(errors.password?.message)
            : undefined
        }
      />
      {/* <div className="flex flex-col gap-2.5"> */}
      {/*   <Button */}
      {/*     id="button-access" */}
      {/*     form="form-customer-login" */}
      {/*     type="submit" */}
      {/*     disabled={isSubmitting||isPending} */}
      {/*     loading={{ state: isSubmitting||isPending, children: 'Acessando...' }} */}
      {/*   > */}
      {/*     Acessar */}
      {/*   </Button> */}
      {/*   <LinkButton */}
      {/*     id="link-customer-first-access" */}
      {/*     href={CLIENT_PATHS.CUSTOMER_FIRST_ACCESS.replace(':websiteId', getWebsiteId(location.href))} */}
      {/*     color="secondary" */}
      {/*     className="mt-0" */}
      {/*   > */}
      {/*     Primeiro acesso */}
      {/*   </LinkButton> */}
      {/* </div> */}
      <Button
        id="button-access"
        form="form-customer-login"
        type="submit"
        disabled={isSubmitting||isPending}
        loading={{ state: isSubmitting||isPending, children: 'Acessando...' }}
      >
        Acessar
      </Button>
    </VerticalForm>
  );
};
